import axios from "axios";
import Config from "../../utils/Config";
const BASE_URL = `${Config.baseUrl}api`;

class DashboardRequests {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("txtconnect_ng_user_token")}`,
      },
    };
  }

  async getUserStats() {
    try {
      const response = await axios.get(
        `${BASE_URL}/user/user_stats`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response?.data?.data,
        message:
          response?.data?.data?.reason || "User stats fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error?.response?.data?.data?.reason || "Sorry, Something went wrong",
      };
    }
  }
}
const dashboardRequests = new DashboardRequests();
export default dashboardRequests;